import { Link as UswdsLink } from '@trussworks/react-uswds';
import { Link as RouterLink } from '@tanstack/react-router';

const InternalLink = ({
  target = '',
  rel = '',
  title = '',
  content = '',
  href = '',
  openInNewTab = false,
  ...customProps
}) => {
  const currentEnv = import.meta.env.VITE_ENVIRONMENT;
  const base = () => {
    if (currentEnv === 'local') {
      return '';
    } else if (currentEnv === 'test_sf') {
      return !openInNewTab ? '' : '/rrssf';
    } else {
      return !openInNewTab ? '' : '/rrs';
    }
  };

  const handleClick = () => {
    if (!openInNewTab && customProps.onClick) {
      customProps.onClick();
    }
  };

  const handleKeyDown = (e) => {
    e.key === 'Enter' && handleClick();
  };

  const sharedProps = {
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    rel: openInNewTab ? 'noopener noreferrer' : rel,
    tabIndex: 0,
    target: openInNewTab ? '_blank' : target,
    title: title ?? content ?? undefined,
    ...customProps,
    className: `usa-link ${customProps.className || ''}`.trim(),
  };

  if (openInNewTab) {
    return (
      <UswdsLink href={base() + href} {...sharedProps}>
        {content ?? href}
      </UswdsLink>
    );
  }

  return (
    <RouterLink to={href} {...sharedProps}>
      {content ?? href}
    </RouterLink>
  );
};

export default InternalLink;
